<template>
  <section id="signin">
        <aside class="msg" v-if="msg.length > 1" @click="closeMsg">
            {{ msg }}
        </aside>

        <section class="code" @keyup="nextVal">
            <input type="text" ref="codeOne" :value="room.one.toUpperCase()" @input="room.one = $event.target.value.toUpperCase()" maxlength="1">
            <input type="text" ref="codeTwo" :value="room.two.toUpperCase()" @input="room.two = $event.target.value.toUpperCase()" maxlength="1">
            <input type="text" ref="codeThree" :value="room.three.toUpperCase()" @input="room.three = $event.target.value.toUpperCase()" maxlength="1">
            <input type="text" ref="codeFour" :value="room.four.toUpperCase()" @input="room.four = $event.target.value.toUpperCase()" maxlength="1">
        </section>
        
        <input type="text" class="name" v-model="name" placeholder="name" ref="nameInput" maxlength="20">
        
        <aside class="public">
            <p>Public Help Board</p>
            <div class="toggle" @click="pub = !pub" :class="{ on : pub }">
                <div class="dot"></div>
            </div>
        </aside>
        
        <button class="btn cta" @click="joinRoom">{{ btnText }}</button>
  </section>
</template>

<script>

export default {
    name: 'SignIn',
    data() {
        return {
            name: '',
            room: {
                one: '',
                two: '',
                three: '',
                four: ''
            },          
            pub: true,
            msg: '',
            btnText: 'Help, I need somebody!'
        }
    },
    methods: {
        nextVal(){
            if(this.room.one !== ''){
                this.$refs.codeTwo.focus();
            }

            if(this.room.one !== '' && this.room.two !== ''){
                this.$refs.codeThree.focus();
            }

            if(this.room.one !== '' && this.room.two !== '' && this.room.three !== ''){
                this.$refs.codeFour.focus();
            }

            if(this.room.one !== '' && this.room.two !== '' && this.room.three !== '' && this.room.four !== ''){
                this.$refs.nameInput.focus();
            }
        },
        joinRoom(){

            this.msg = '';

            if(this.name === '') {
                this.msg += 'Name missing. ';
            } 
            
            if(this.room === '') {
                this.msg += 'Room missing. ';
            } 
            
            if (this.room.one.length === 0 || this.room.two.length === 0 ||
                  this.room.three.length === 0 || this.room.four.length === 0 ) {
                this.msg += 'Room must contain 4 characters.';
            } 
    
            if(this.room.one.length > 0 || this.room.two.length > 0 || this.room.three.length > 0 || this.room.four.length > 0 && this.name.length) {

                this.btnText = 'Joining room...';
                const room = Object.values(this.room).join('');
                this.$store.dispatch('joinRoom', { name: this.name, room: room, public: this.pub });
            }
        },
        closeMsg(){
            this.msg = '';
        },
        roomExist() {
            console.log(this.room)
        }
    },
    computed: {
        user(){
            return this.$store.state.user;
        }
    },
    mounted(){
        this.$refs.codeOne.focus();
    }
}
</script>

<style lang="scss">
@import './../scss/variables';

#signin {
    max-width: 300px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background: $white;
    border-radius: $innerRadius;
    
    .msg {
        padding: .5rem;
        background: rgba($color: $red, $alpha: .2);
    }

    .name {
        appearance: none;
        outline: none;
        border: .125rem solid $darkGrey;
        border-radius: $innerRadius;
        font-size: 1.1rem;
        padding: 1rem;
        font-family: $mainFont;
    }

    aside {
        display: flex;
        justify-content: space-between;

        p {
            margin: 0;
            padding: 0;
        }
    }

    .code {
        display: flex;
        gap: 1rem;

        > input {
            padding: 0;
            margin: 0;
            width: 25%;
            border-radius: .25rem;
            height: 5rem;
            background: $grey;
            box-sizing: border-box;
            border: none;
            font-size: 2.4rem;
            text-align: center;

            &:focus {
                outline: none;
            }
        }
    }
}

</style>